import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";

export default function Employee() {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable name="Employee" title="Nhân viên" />
      </Container>
    </div>
  );
}
